import React from "react";
import _ from "lodash";
import moment from "moment";
import {getTransactionType} from "../../../../../utils";
import {
  TRANSACTION_INSTR,
  TRANSACTION_INSTR_ORDERING_FIELD_NAMES,
  TRANSACTION_START_DATE,
  TRANSACTION_TYPE_VALUES,
} from "../../../../../constants";
import {getAssetInternalId} from "../../../../../../CustomerDashboard/utils";
import {initEinzeltitelSettings} from "../../../../../../RiskProfiling/einzeltitel_helper";


/**
 * Hook that initializes transaction defaults (transaction_type, deposit_from_type, sell_all)
 * and builds the transactionsByProduct lookup map.
 *
 * This logic runs on every render to ensure new instruments get defaults applied.
 */
const useTransactionSetup = ({portfolio, transactions, isVirtual, quotationFieldsSource, handleSellAllChanged}) => {

  const transactionsByProduct = {};

  [TRANSACTION_TYPE_VALUES.BUY, TRANSACTION_TYPE_VALUES.SELL, TRANSACTION_TYPE_VALUES.SWITCH].forEach(transaction => {
    transactionsByProduct[transaction] = {};
    const availableOrderingFields = portfolio[quotationFieldsSource[transaction]];
    const sellAllAvailable = availableOrderingFields.includes(TRANSACTION_INSTR_ORDERING_FIELD_NAMES.is_all);
    const qtyAvailable = availableOrderingFields.includes(TRANSACTION_INSTR_ORDERING_FIELD_NAMES[TRANSACTION_INSTR.qty]);

    (transactions[transaction] || []).forEach(instr => {
      // Set default transaction type
      if (typeof instr.transaction_type === 'undefined') {
        instr.transaction_type = getTransactionType(portfolio, transaction);
      }

      // Set default deposit date/type
      if (typeof instr.deposit_from_type === 'undefined') {
        if (isVirtual) {
          const priceDate = _.get(instr, 'data.price_date') || _.get(instr, 'data.calculated.last_price_date');
          instr.deposit_from_date = priceDate ? moment(priceDate, 'YYYY-MM-DD') : undefined;
          instr.deposit_from_type = TRANSACTION_START_DATE.date;
        } else {
          instr.deposit_from_type = TRANSACTION_START_DATE.rightAway;
        }
      }

      if(!instr.data.is_fund && !portfolio.isModelportfolio) {
        initEinzeltitelSettings(instr, portfolio.stock_exchange_options)
      }

      // Auto sell-all for wholeDepotOrder instruments
      if (typeof instr.sell_all === 'undefined' && instr.data.wholeDepotOrder && (sellAllAvailable || qtyAvailable)) {
        handleSellAllChanged(instr, true, sellAllAvailable);
      }

      transactionsByProduct[transaction][getAssetInternalId(instr.data)] = instr;
    });
  });

  return {transactionsByProduct};
};

export default useTransactionSetup;
